module.exports = __webpack_public_path__ + "img/14.d5f8cda8.jpg";